namespace Solovis.InvDataSelectors {

    export class TagSetSelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public selectionCallback;
        public cancelCallback;
        public _filter;

        public _currentTagSet;

        public _filterListControl;
        public tagSets;
        public tagSetList;

        private _availableHeight;


        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;

            this._filter = options.filter ? options.filter : {};

            this._currentTagSet = options.initialValue ? options.initialValue : null;
        }



        public doInitAsync() {
            var self = this;

            var filterOptions: any = {};
            if (this._filter && this._filter.exposureProfileId) {
                filterOptions.exposureProfileId = this._filter.exposureProfileId;
            }

            this._portalServices.rpc().invoke(
                "~/Selectors/TagSelector/GetTagSetList",
                filterOptions,
                function (response, success) {
                    if (success) {
                        self.tagSets = response.result.tagSets;

                        var tagSetList = [];
                        $(self.tagSets).each(function (i, tagSet) {
                            tagSetList.push(tagSet);
                        });

                        tagSetList.sort(function (a, b) {
                            if (a.label < b.label) {
                                return -1;
                            }
                            else if (a.label > b.label) {
                                return 1;
                            }
                            else {
                                return 0;
                            }
                        });

                        self.tagSetList = tagSetList;
                    }

                    self.notifyInitComplete();
                });
        }

        public setAvailableHeight(overallHeight) {
            if (overallHeight) {
                if (this._filterListControl && this._filterListControl.state >= Solovis.UI.BaseControl.ControlState.afterRender) {
                    this._filterListControl.setAvailableHeight(overallHeight);
                }
                else {
                    // The control is still rendering, so save the height and for use once the control is rendered
                    this._availableHeight = overallHeight;
                }
            }
        }

        public doRender() {
            var self = this;

            var selectorControlHostDiv = $("<div>")
                .appendTo(this.container);

            var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });

            this._filterListControl = new Solovis.UI.StringFilterListControl({
                controlHost: selectorControlHostDiv,
                listItems: this.tagSetList,
                useDefaultSort: true,
                selectedItem: this._currentTagSet ? this._currentTagSet : null
            });

            $(this._filterListControl)
                .on("selectionChanged", function (e, data) {
                    var selectedTagSet = data.item;
                    self.selectionCallback(selectedTagSet);
                })
                .on("renderComplete", function () {
                    if (self._availableHeight) {
                        self._filterListControl.setAvailableHeight(self._availableHeight);
                        self._availableHeight = null;
                    }
                    if (self._currentTagSet) {
                        self._filterListControl.scrollToSelectedItem();
                    }

                    self._filterListControl.focusFilter();
                })
                .on("escapeKey", function () {
                    if (self.cancelCallback) {
                        self.cancelCallback();
                    }
                });

            selectorControlHost.setCurrentControl(this._filterListControl);
        }

    }

}
